<script setup>
import { onMounted, nextTick } from 'vue'
import { ScrollSpy } from 'bootstrap'

import Introduction from '@/views/Authenticated/Docs/Api/Sections/Introduction.vue'
import Access from '@/views/Authenticated/Docs/Api/Sections/Access.vue'
import Authentication from '@/views/Authenticated/Docs/Api/Sections/Authentication.vue'
import ResponseTypes from '@/views/Authenticated/Docs/Api/Sections/ResponseTypes.vue'
import FairUse from '@/views/Authenticated/Docs/Api/Sections/FairUse.vue'

import IpInfo from '@/views/Authenticated/Docs/Api/Sections/IpInfo.vue'
import IpBulk from '@/views/Authenticated/Docs/Api/Sections/IpBulk.vue'
import EventSearch from '@/views/Authenticated/Docs/Api/Sections/EventSearch.vue'

import ListDatasets from '@/views/Authenticated/Docs/Api/Sections/ListDataset.vue'
import DownloadDataset from '@/views/Authenticated/Docs/Api/Sections/DownloadDataset.vue'

onMounted( async () => {
  await nextTick()

  // Small delay to ensure DOM is fully rendered after navigation
  const scrollContainer = document.getElementById('main-scroll-container')
  const navbar = document.getElementById('navbar-docs')

  if (scrollContainer && navbar) {
    // Dispose any existing ScrollSpy instance first
    const existingInstance = ScrollSpy.getInstance(scrollContainer)
    if (existingInstance) {
      existingInstance.dispose()
    }

    // Initialize ScrollSpy on the scrolling container
    ScrollSpy.getOrCreateInstance(scrollContainer, {
      target: '#navbar-docs',
      smoothScroll: true
    })
  }
})

</script>

<template>
  <div class="d-flex column">
    <div class="container-fluid">
      <div class="row">
        <!-- Content -->
        <div class="col-md-10 pb-4 wp">
            <!-- GENERAL INFORMATION -->
            <Introduction id="item-1"/>
            <Access id="item-2"/>
            <ResponseTypes id="item-3"/>
            <Authentication id="item-4"/>
            <FairUse id="item-5"/>

            <!-- API SECTIONS -->
            <IpInfo id="item-6"/>
            <IpBulk id="item-7"/>
            <EventSearch id="item-8"/>
            <!--
            <ListDatasets id="item-9"/>
            <DownloadDataset id="item-10"/>
            -->
        </div>

        <!-- Navigation -->
        <div class="col-md-2 sidebar">
          <div style="position: sticky; top: 0;">
            <strong class="mb-2 d-flex"><small>General information</small></strong>
            <hr>

            <nav id="navbar-docs" class="">
              <nav class="nav flex-column">
                <a class="nav-link" href="#item-1">Introduction</a>
                <a class="nav-link" href="#item-2">Response types</a>
                <a class="nav-link" href="#item-4">Authentication</a>
                <a class="nav-link" href="#item-5">Fair use</a>

                <strong class="mb-2 d-flex mt-4"><small>Reference</small></strong>
                <hr>
                <a class="nav-link" href="#item-6">IP lookup</a>
                <a class="nav-link" href="#item-7">IP bulk</a>
                <a class="nav-link" href="#item-8">Event Search</a>
              </nav>

            </nav>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>



<style scoped>
.sidebar {
  border-left: 1px solid #1e252f;
}

.list-group-item {
  background-color: #191f27;
  border-color: #1e252f;
  color: #6d7785;
}

.list-group-item:hover {
  background-color: #1c222b
}

.router-link-exact-active {
  font-weight: 500 !important;
  color: white !important;
}

.wp > * {
  margin-top: 2.5rem;
}

.wp > *:not(:first-child) {
  border-top: 2px solid #1e252f;
  padding-top: 2.5rem;
}

#navbar-docs a {
  color: #6d7785;
  border-left: 5px solid transparent;
  transition: .5s ease;
}

#navbar-docs a.active {
  color: white;
  border-color: #bf75fe;
}
</style>
